export interface PasswordRequirement {
  id: string;
  label: string;
  test: (password: string) => boolean;
}

export const PASSWORD_REQUIREMENTS: PasswordRequirement[] = [
  {
    id: 'length',
    label: 'Minimum 15 characters',
    test: (password) => password.length >= 15,
  },
  {
    id: 'case',
    label: 'At least 1 uppercase and 1 lowercase letter',
    test: (password) => /[A-Z]/.test(password) && /[a-z]/.test(password),
  },
  {
    id: 'number',
    label: 'At least 1 number',
    test: (password) => /\d/.test(password),
  },
  {
    id: 'special',
    label: 'At least 1 special character (E.g: @,$,%,^,*)',
    test: (password) => /[@$%^*!?&+#\-_=~`|\\:;"'<>,./[\]{}()]/.test(password),
  },
];

export type PasswordStrengthLabel = 'Weak' | 'Medium' | 'Strong';

export interface PasswordStrength {
  label: PasswordStrengthLabel;
  percent: number;
  metCount: number;
}

export function getPasswordStrength(password: string): PasswordStrength {
  const metCount = PASSWORD_REQUIREMENTS.filter((req) => req.test(password)).length;

  if (metCount <= 1) {
    return { label: 'Weak', percent: Math.max(metCount * 25, password.length > 0 ? 15 : 0), metCount };
  }
  if (metCount <= 3) {
    return { label: 'Medium', percent: metCount * 25, metCount };
  }
  return { label: 'Strong', percent: 100, metCount };
}

export function isPasswordValid(password: string): boolean {
  return PASSWORD_REQUIREMENTS.every((req) => req.test(password));
}
